import React from 'react'
import { Modal, ModalProps, Stack } from '@thirstycamel/ui'

import RegisterForm from '../RegisterForm/RegisterForm'

export interface ModalSignupToSaveProps extends ModalProps {}

const ModalSignupToSave: React.FC<ModalSignupToSaveProps> = ({ isVisible, onClose }) => {
  return (
    <Modal
      onClose={onClose}
      isVisible={isVisible}
      heading="Sign up to unlock member pricing"
      maxW="56rem"
    >
      <Stack py={2} spacing={4}>
        <RegisterForm defaultValues={{}} onSuccess={() => onClose()} layoutVariant="modal" />
      </Stack>
    </Modal>
  )
}

export default ModalSignupToSave
